import getBorderFocusStyles from '../../getBorderFocusStyles';
var tableCellStyles = {
  root: function root(_ref) {
    var v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var borderFocusStyles = getBorderFocusStyles({
      variables: siteVariables
    });
    return Object.assign({
      display: 'flex',
      flexFlow: 'row nowrap',
      flexGrow: 1,
      flexBasis: 0,
      minWidth: v.minCellWidth,
      outline: 0,
      borderWidth: v.borderWidth,
      borderStyle: 'solid',
      borderColor: 'transparent'
    }, borderFocusStyles, {
      padding: v.cellPadding,
      position: 'relative',
      height: '100%'
    });
  },
  content: function content(_ref2) {
    var p = _ref2.props;
    return Object.assign({
      alignSelf: 'center'
    }, p.truncateContent && {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    });
  }
};
export default tableCellStyles;
//# sourceMappingURL=tableCellStyles.js.map
